import React, { useState } from 'react';
import SystemBanners from './SystemBanners';
import SystemBannerSidebar from './SystemBannerSidebar';
import TabSelection from './components/TabSelection';

const tabs = [
  {
    label: 'System Banners',
    show: { search: true, filters: { status: true, banner_type: true } },
  },
];

const SystemBannersIndex = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState({});
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [openSideActionBoard, setOpenSideActionBoard] = useState(null);
  const [refetchBanners, setRefetchBanners] = useState(null);

  return (
    <div>
      {openSideActionBoard && (
        <SystemBannerSidebar
          openSideActionBoard={openSideActionBoard}
          setOpenSideActionBoard={setOpenSideActionBoard}
          onSuccess={refetchBanners}
        />
      )}
      <TabSelection
        tabs={tabs}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filter={filter}
        setFilter={setFilter}
        setOpenSideActionBoard={setOpenSideActionBoard}
      />
      <div style={{ gap: '64px' }} className="flex flex-col">
        {currentTab?.label === 'System Banners' && (
          <SystemBanners
            searchQuery={searchQuery}
            filter={filter}
            setOpenSideActionBoard={setOpenSideActionBoard}
            setRefetchBanners={setRefetchBanners}
          />
        )}
      </div>
    </div>
  );
};

export default SystemBannersIndex;

